import { isDevMode } from '@angular/core';
import {
  CellStyleModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  CsvExportModule,
  CustomFilterModule,
  EventApiModule,
  GridStateModule,
  ModuleRegistry,
  NumberFilterModule,
  PaginationModule,
  provideGlobalGridOptions,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowSelectionModule,
  RowStyleModule,
  TextEditorModule,
  TextFilterModule,
  TooltipModule,
  ValidationModule,
} from 'ag-grid-community';
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  FiltersToolPanelModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
} from 'ag-grid-enterprise';

/**
 * Registers the ag-grid feature modules the grid stack needs and pins the legacy
 * theme. Every consumer calls this once at module scope, before the first grid.
 */
export function registerSensikaGridModules(): void {
  // Only the ag-grid features the app uses (WAP-1714); a feature used without its
  // module fails at runtime with a message naming the module - add it here.
  // Sorting, column move / resize / groups and keyboard navigation are core.
  ModuleRegistry.registerModules([
    // Row models: SSRM for app-data-grid and the remediation grids, client-side
    // for the two translation tables and Remediation Runs.
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    ClientSideRowModelModule,
    // Filters: provided text / number / set plus the Angular custom filters.
    TextFilterModule,
    NumberFilterModule,
    SetFilterModule,
    CustomFilterModule,
    // Toolbar-adjacent chrome: side panels, header menu, default context menu
    // on the standalone grids (the wrapper suppresses it).
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ColumnMenuModule,
    ContextMenuModule,
    // Selection, range copy, paging, state, tooltips.
    RowSelectionModule,
    CellSelectionModule,
    ClipboardModule,
    PaginationModule,
    GridStateModule,
    TooltipModule,
    // Styling and layout hooks used by column defs.
    CellStyleModule,
    RowStyleModule,
    RowAutoHeightModule,
    ColumnAutoSizeModule,
    // Editing (default text editor) and export.
    TextEditorModule,
    CsvExportModule,
    // Grid API surface the wrapper and hosts call.
    ColumnApiModule,
    RenderApiModule,
    RowApiModule,
    EventApiModule,
    // Dev only: readable errors when a feature lacks its module.
    ...(isDevMode() ? [ValidationModule] : []),
  ]);

  // Mark all grids as using the legacy theme
  provideGlobalGridOptions({ theme: 'legacy' });
}
